import { createFileRoute } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import { SeoLayout } from '@/components/astro/new-design-25/SEO/seo-layout';
import { seo } from '@/seo/seo';

const heroTitle = 'Natural Sounding Text to Speech';
const heroDescription =
  "Experience the most natural-sounding text to speech voices available. Advanced AI technology creates human-like speech that's comfortable for extended listening.";

const featureTitle = heroTitle;
const featureSubtitle = 'Human-quality AI voices';
const featureDescription = heroDescription;
const featureBadge = 'Premium Quality';
const featureVariant = 'default';
const featureCtaText = 'Hear Natural Voices';

const featureFeatures = [
  {
    title: 'Lifelike Pronunciation',
    description:
      'Advanced neural networks create voices that sound incredibly human with natural intonation and rhythm.',
  },
  {
    title: 'Emotion and Expression',
    description:
      'Voices that convey appropriate emotion and emphasis, making content more engaging and easier to follow.',
  },
  {
    title: 'Extended Listening Comfort',
    description:
      'Natural voices reduce listener fatigue during long audio sessions compared to robotic alternatives.',
  },
];

export const Route = createFileRoute(
  '/_marketing/_seo/natural-sounding-text-to-speech',
)({
  beforeLoad: assertPublicToolsEnabled,
  head: () => ({
    meta: [
      ...seo({
        title:
          'Natural Sounding Text to Speech - Human-Like AI Voices | Listening',
        description:
          'Experience the most natural text to speech voices. Advanced AI creates human-like speech perfect for extended listening. No robotic voices.',
      }),
    ],
  }),
  component: () => (
    <SeoLayout
      featureBadge={featureBadge}
      featureCtaText={featureCtaText}
      featureDescription={featureDescription}
      featureFeatures={featureFeatures}
      featureSubtitle={featureSubtitle}
      featureTitle={featureTitle}
      featureVariant={featureVariant}
      pageDescription={heroDescription}
      pageTitle={heroTitle}
    />
  ),
});
